import { PortOvertimeLevel } from '../enums/port-overtime-level.enum';

// A single applied overtime segment for a PDA line, as returned by the API's
// `overtimeApplications` array. A line can have many applications per level
// (one per time segment the proration engine walked through), so these are
// aggregated by level for display — never one-to-one with a table row.
// Purely presentational — amounts and minutes are computed server-side and
// consumed as-is, never recalculated here.
export class PortCallPdaLineOvertimeEntryModel {
  constructor(
    public id?: any,
    public level?: PortOvertimeLevel | string,
    public minutes?: string | number | null,
    public appliedRateValue?: string | null,
    public originalRateValue?: string | null,
    public calculatedAmountUsd?: string | null,
    // Set when this segment had no complete OT formula of its own and the Regular
    // formula was applied instead — identifies which fallback rule kicked in.
    public fallbackCode?: string | null,
    public status?: string | null,
    public warning?: string | null
  ) {}

  public fromJSON(json: any): PortCallPdaLineOvertimeEntryModel {
    if (json) {
      this.id = json.id;
      this.level = json.level;
      this.minutes = json.minutes ?? null;
      this.appliedRateValue = json.appliedRateValue ?? null;
      this.originalRateValue = json.originalRateValue ?? null;
      this.calculatedAmountUsd = json.calculatedAmountUsd ?? null;
      this.fallbackCode = json.fallbackCode ?? null;
      this.status = json.status ?? null;
      this.warning = json.warning ?? null;
    }
    return this;
  }

  public fromJSONList(json: any): PortCallPdaLineOvertimeEntryModel[] {
    if (Array.isArray(json)) {
      return json.map((element: any) => new PortCallPdaLineOvertimeEntryModel().fromJSON(element));
    }
    return [];
  }

  public toJSON() {
    return {
      id: this.id,
      level: this.level,
      minutes: this.minutes,
      appliedRateValue: this.appliedRateValue,
      originalRateValue: this.originalRateValue,
      calculatedAmountUsd: this.calculatedAmountUsd,
      fallbackCode: this.fallbackCode,
      status: this.status,
      warning: this.warning,
    };
  }
}
